<template>
  <div>
    <v-alert max-width="800" class="mt-6 mx-auto d-flex" type="error" style="text-align:center" text><span v-html="message" /></v-alert>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: "Erreur interne"
    }
  }
}
</script>

<style>

</style>